module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gadNr"))).then(() => parcelRequire('cvs7o'));